import React, { useState, useEffect } from 'react';
import { useFormik } from "formik";
import * as Yup from "yup";
import { IoClose } from 'react-icons/io5';
import { MdFastfood } from "react-icons/md";
import { CImage } from '@coreui/react';
import ImageUploading from 'react-images-uploading';
import { toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import { useTranslation } from 'react-i18next';

import InputMoney from "../ListItem/InputMoney";
import { updateItemAdicional } from "../../services/api";
import '../../styles/modal-shared.css';

const ModalEditItemAdicional = ({
    setShowEditItemAdicional,
    showEditItemAdicional,
    setRefresh,
    itemAdicionalToEdit,
    idGrupoToEdit,
    typeGrupo = "simples"
}) => {
    const { t } = useTranslation('categorias');
    const isSabor = typeGrupo === "pizza";

    const id_grupo = idGrupoToEdit;
    const [adicional, setAdicional] = useState(itemAdicionalToEdit ?? null);
    const userID = "sad29389das32f";

    const [valuePreco, setValuePreco] = useState(adicional ? adicional.price : 0);
    const [valuePrecoSalao, setValuePrecoSalao] = useState(adicional ? adicional.price_salao : 0);
    const [savingAdicional, setSavingAdicional] = useState(false);

    const imagesFromDb = adicional?.image;
    const imagesArray = imagesFromDb === "" || !imagesFromDb ? [] : [{ data_url: imagesFromDb }];

    const [imagesToString, setImagesToString] = useState(imagesFromDb);
    const [images, setImages] = useState(imagesArray);
    const maxNumber = 1;
    const maxMbFileSize = 2 * 1024 * 1024;

    const onChangeImg = (imageList) => {
        setImages(imageList);
        const str = imageList.length > 0 ? imageList.map(image => image.data_url).join(", ") : "";
        setImagesToString(str);
    };

    const SignUpSchema = Yup.object().shape({
        title: Yup.string().required(t('actions.required')),
    });

    const formik = useFormik({
        validationSchema: SignUpSchema,
        validateOnBlur: false,
        validateOnChange: false,
        initialValues: {
            title: itemAdicionalToEdit ? itemAdicionalToEdit.title : "",
        },
        onSubmit: (values) => handleSubmitAPI(values.title),
    });

    useEffect(() => {
        if (itemAdicionalToEdit) {
            formik.setValues(prev => ({ ...prev, title: itemAdicionalToEdit.title }));
            setValuePreco(itemAdicionalToEdit.price);
            setValuePrecoSalao(itemAdicionalToEdit.price_salao ?? 0);
            setAdicional(itemAdicionalToEdit);

            // Reset images
            const img = itemAdicionalToEdit.image;
            const arr = !img || img === "" ? [] : [{ data_url: img }];
            setImages(arr);
            setImagesToString(img || "");
        }
    }, [showEditItemAdicional, itemAdicionalToEdit]);

    const onChange = (event, nameObject, isNumber) => {
        setValuePreco(isNumber ? Number(event.target.value) : event.target.value);
        formik.setFieldValue("preco", isNumber ? Number(event.target.value) : event.target.value);
    };

    const onChangeSalao = (event, nameObject, isNumber) => {
        setValuePrecoSalao(isNumber ? Number(event.target.value) : event.target.value);
        formik.setFieldValue("preco_salao", isNumber ? Number(event.target.value) : event.target.value);
    };

    const handleBack = () => setShowEditItemAdicional(!showEditItemAdicional);

    const handleSubmitAPI = (title) => {
        setSavingAdicional(true);
        const price = valuePreco;
        const price_salao = valuePrecoSalao;
        const _id = adicional._id;
        const id_adicional = adicional.id_adicional;
        const image = imagesToString;

        const categoriaData = { userID, _id, id_adicional, id_grupo, title, price, image, price_salao };

        updateItemAdicional(categoriaData).then(response => {
            if (response.status === 200) {
                toast(response.data.msg, { autoClose: 5000, type: "success" });
            } else {
                toast(response.data.msg, { autoClose: 5000, type: "error" });
            }
        }).catch(err => {
            toast(err.response?.data?.msg || t('item.updateError'), { autoClose: 5000, type: "error" });
        }).finally(() => {
            setSavingAdicional(false);
            setShowEditItemAdicional(!showEditItemAdicional);
            setRefresh(prev => !prev);
        });
    };

    return (
        <div className={showEditItemAdicional ? 'pdj-modal-overlay' : 'pdj-modal-overlay--hidden'}>
            <div className="pdj-modal-box">
                <form onSubmit={formik.handleSubmit}>

                    {/* Header */}
                    <div className="pdj-modal-header">
                        <div className="pdj-modal-header-text">
                            <h2 className="pdj-modal-title">{t('editAdditionalModal.title')}</h2>
                        </div>
                        <button type="button" className="pdj-modal-close-btn" onClick={handleBack}>
                            <IoClose />
                        </button>
                    </div>

                    {/* Body */}
                    <div className="pdj-modal-body">

                        {/* Nome */}
                        <div className="pdj-modal-field">
                            <label className="pdj-modal-label">
                                {t('editAdditionalModal.name')}
                                <span className="pdj-modal-required">*</span>
                            </label>
                            <input
                                className="pdj-modal-input"
                                placeholder={t('editAdditionalModal.namePlaceholder')}
                                id="title"
                                type="text"
                                name="title"
                                onChange={formik.handleChange}
                                value={formik.values.title}
                            />
                            {formik.errors.title && (
                                <span className="pdj-modal-error">{formik.errors.title}</span>
                            )}
                        </div>

                        {/* Precos */}
                        <div className="pdj-modal-grid-2">
                            <div className="pdj-modal-field">
                                <label className="pdj-modal-label">
                                    {t('editAdditionalModal.priceDelivery')}
                                </label>
                                <InputMoney
                                    onChange={(event) => onChange(event, 'price', true)}
                                    value={valuePreco}
                                    className="pdj-modal-input"
                                    placeholder="0,00"
                                />
                            </div>

                            <div className="pdj-modal-field">
                                <label className="pdj-modal-label">
                                    {t('editAdditionalModal.priceSalon')}
                                </label>
                                <InputMoney
                                    onChange={(event) => onChangeSalao(event, 'price_salao', true)}
                                    value={valuePrecoSalao}
                                    className="pdj-modal-input"
                                    placeholder="0,00"
                                />
                            </div>
                        </div>

                        {/* Imagem */}
                        <div className="pdj-modal-field">
                            <label className="pdj-modal-label">
                                {t('editAdditionalModal.image')}
                            </label>
                            <ImageUploading
                                multiple
                                value={images}
                                onChange={onChangeImg}
                                maxNumber={maxNumber}
                                maxFileSize={maxMbFileSize}
                                acceptType={["jpg", "jpeg", "png", "webp"]}
                                dataURLKey="data_url"
                            >
                                {({
                                    imageList,
                                    onImageUpload,
                                    onImageUpdate,
                                    onImageRemove,
                                    isDragging,
                                    dragProps,
                                    errors
                                }) => (
                                    <div>
                                        <div
                                            onClick={images.length === 0 ? onImageUpload : undefined}
                                            {...dragProps}
                                            className={`pdj-modal-upload${isDragging ? ' pdj-modal-upload--dragging' : ''}${imageList.length > 0 ? ' pdj-modal-upload--has-image' : ''}`}
                                        >
                                            {imageList.length === 0 && (
                                                <>
                                                    <MdFastfood className="pdj-modal-upload-icon" />
                                                    <div className="pdj-modal-upload-title">
                                                        {t('addItemModal.imageChoose')}
                                                    </div>
                                                    <div className="pdj-modal-upload-hint">
                                                        {isDragging ? "Solte aqui..." : t('addItemModal.imageDragDrop')}
                                                    </div>
                                                </>
                                            )}
                                            {imageList.map((image, index) => (
                                                <div key={index} className="pdj-modal-upload-preview">
                                                    <CImage
                                                        rounded
                                                        fluid
                                                        src={image['data_url']}
                                                        style={{ maxHeight: '140px', maxWidth: '100%', borderRadius: '8px' }}
                                                    />
                                                    <div className="pdj-modal-upload-actions">
                                                        <button
                                                            type="button"
                                                            className="pdj-modal-btn pdj-modal-btn--secondary"
                                                            onClick={(e) => { e.stopPropagation(); onImageUpdate(index); }}
                                                        >
                                                            {t('addItemModal.imageChange')}
                                                        </button>
                                                        <button
                                                            type="button"
                                                            className="pdj-modal-btn pdj-modal-btn--danger"
                                                            onClick={(e) => { e.stopPropagation(); onImageRemove(index); }}
                                                        >
                                                            {t('addItemModal.imageRemove')}
                                                        </button>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>

                                        {errors && (
                                            <div style={{ marginTop: '4px' }}>
                                                {errors.maxNumber && <span className="pdj-modal-error">{t('addItemModal.imageMaxNumber')}</span>}
                                                {errors.acceptType && <span className="pdj-modal-error">{t('addItemModal.imageInvalidFormat')}</span>}
                                                {errors.maxFileSize && <span className="pdj-modal-error">{t('addItemModal.imageMaxFileSize')}</span>}
                                            </div>
                                        )}

                                        <div className="pdj-modal-upload-info">
                                            {t('addItemModal.imageMaxSize')}
                                        </div>
                                    </div>
                                )}
                            </ImageUploading>
                        </div>

                    </div>

                    {/* Footer */}
                    <div className="pdj-modal-footer">
                        <button type="button" className="pdj-modal-btn pdj-modal-btn--secondary" onClick={handleBack}>
                            {t('actions.cancel')}
                        </button>
                        <button
                            type="submit"
                            className="pdj-modal-btn pdj-modal-btn--primary"
                            disabled={savingAdicional}
                        >
                            {savingAdicional ? t('addItemModal.saving') : t('actions.save')}
                        </button>
                    </div>

                </form>
            </div>
        </div>
    );
};

export default ModalEditItemAdicional;
